package gr.tech.GRAttestation.sections.forms

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.GRAttestation.components.inputs.GRStringInput
import gr.tech.GRAttestation.components.inputs.StoreStatusDropdown
import gr.tech.GRAttestation.models.stores.STORE_STATUS
import gr.tech.GRAttestation.models.stores.StoreDTO
import gr.tech.GRAttestation.styles.GeneralFormErrorTextStyle
import gr.tech.util.validateInput
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun StoreForm(
    storeInformation: StoreDTO,
    formError: String,
    onSubmit: (StoreDTO) -> Unit,
) {
    var form by remember { mutableStateOf(storeInformation) }

    var storeNameError by remember { mutableStateOf("") }
    var storeLocationIDError by remember { mutableStateOf("") }
    var storeRepError by remember { mutableStateOf("") }
    var storeAddressError by remember { mutableStateOf("") }
    var storeCityError by remember { mutableStateOf("") }
    var storeStateError by remember { mutableStateOf("") }
    var storeZipError by remember { mutableStateOf("") }

    var status by remember(storeInformation) { mutableStateOf(STORE_STATUS.parseStatus(storeInformation.status)) }

    LaunchedEffect(Unit) {
        storeNameError = form.storeName.validateInput(minLength = 3, maxLength = 128)
        storeLocationIDError = form.locationId.validateInput(minLength = 3, maxLength = 128)
        storeRepError = form.storeRep.validateInput(minLength = 3, maxLength = 128)
    }

    Column(
        modifier = Modifier.margin(top = 8.px),
        horizontalAlignment = Alignment.Start
    ) {
        GRStringInput(
            direction = FlexDirection.Column,
            inputId = "StoreFormStoreName",
            labelText = "Store Name",
            value = form.storeName,
            hasError = storeNameError.isNotBlank(),
            labelError = storeNameError,
            labelModifier = Modifier
                .whiteSpace(WhiteSpace.NoWrap)
                .fontWeight(FontWeight.Bold)
                .margin(bottom = 8.px),
            inputModifier = Modifier,
        ) {
            form = form.copy(
                storeName = it.value,
            )
            storeNameError = it.value.validateInput(minLength = 3, maxLength = 128)
        }

        GRStringInput(
            direction = FlexDirection.Column,
            inputId = "StoreFormLocationId",
            labelText = "Location ID",
            value = form.locationId,
            hasError = storeLocationIDError.isNotBlank(),
            labelError = storeLocationIDError,
            labelModifier = Modifier
                .whiteSpace(WhiteSpace.NoWrap)
                .fontWeight(FontWeight.Bold)
                .margin(bottom = 8.px),
            inputModifier = Modifier,
        ) {
            form = form.copy(
                locationId = it.value,
            )
            storeLocationIDError = it.value.validateInput(minLength = 3, maxLength = 128)
        }

        GRStringInput(
            direction = FlexDirection.Column,
            inputId = "StoreFormAddress",
            labelText = "Address",
            value = form.storeAddress,
            hasError = storeAddressError.isNotBlank(),
            labelError = storeAddressError,
            labelModifier = Modifier
                .whiteSpace(WhiteSpace.NoWrap)
                .fontWeight(FontWeight.Bold)
                .margin(bottom = 8.px),
            inputModifier = Modifier,
        ) {
            form = form.copy(
                storeAddress = it.value,
            )
            storeAddressError = it.value.validateInput(minLength = 3, maxLength = 128)
        }

        GRStringInput(
            direction = FlexDirection.Column,
            inputId = "StoreFormCity",
            labelText = "City",
            value = form.storeCity,
            hasError = storeCityError.isNotBlank(),
            labelError = storeCityError,
            labelModifier = Modifier
                .whiteSpace(WhiteSpace.NoWrap)
                .fontWeight(FontWeight.Bold)
                .margin(bottom = 8.px),
            inputModifier = Modifier,
        ) {
            form = form.copy(
                storeCity = it.value,
            )
            storeCityError = it.value.validateInput(minLength = 3, maxLength = 128)
        }

        GRStringInput(
            direction = FlexDirection.Column,
            inputId = "StoreFormState",
            labelText = "State",
            value = form.storeState,
            hasError = storeStateError.isNotBlank(),
            labelError = storeStateError,
            labelModifier = Modifier
                .whiteSpace(WhiteSpace.NoWrap)
                .fontWeight(FontWeight.Bold)
                .margin(bottom = 8.px),
            inputModifier = Modifier,
        ) {
            form = form.copy(
                storeState = it.value,
            )
            storeStateError = it.value.validateInput(minLength = 2, maxLength = 128)
        }

        GRStringInput(
            direction = FlexDirection.Column,
            inputId = "storeFormZip",
            labelText = "ZIP",
            value = form.storeZip,
            hasError = storeZipError.isNotBlank(),
            labelError = storeZipError,
            labelModifier = Modifier
                .whiteSpace(WhiteSpace.NoWrap)
                .fontWeight(FontWeight.Bold)
                .margin(bottom = 8.px),
            inputModifier = Modifier,
        ) {
            form = form.copy(
                storeZip = it.value,
            )
            storeZipError = it.value.validateInput(minLength = 3, maxLength = 128)
        }

        GRStringInput(
            direction = FlexDirection.Column,
            inputId = "StoreFormRepName",
            labelText = "Rep Name",
            value = form.storeRep,
            hasError = storeRepError.isNotBlank(),
            labelError = storeRepError,
            labelModifier = Modifier
                .whiteSpace(WhiteSpace.NoWrap)
                .fontWeight(FontWeight.Bold)
                .margin(bottom = 8.px),
            inputModifier = Modifier,
        ) {
            form = form.copy(
                storeRep = it.value,
            )
            storeRepError = it.value.validateInput(minLength = 3, maxLength = 128)
        }

        // Status Dropdown
        StoreStatusDropdown(
            selected = status,
            onValueChange = {
                form = form.copy(
                    status = it.bit
                )
            }
        )

        key(formError) {
            P(GeneralFormErrorTextStyle.toModifier().toAttrs()) {
                Text(formError)
            }
        }

        Button(
            attrs = Modifier
                .disabled(
                    storeRepError.isNotBlank() || storeNameError.isNotBlank() || storeLocationIDError.isNotBlank() ||
                            storeAddressError.isNotBlank() || storeCityError.isNotBlank() || storeStateError.isNotBlank() || storeZipError.isNotBlank()
                )
                .classNames("btn", "btn-primary")
                .margin(top = 16.px)
                .onClick { onSubmit(form) }
                .toAttrs()
        ) {
            Text("Submit")
        }
    }
}